import React from 'react';
import { useTranslation } from '@lib/useTypedTranslation';
import { Button } from '../../../../../../../components/controls/button';
import { ButtonColours } from '../../../../../../../containers/app/themes';
import '../resetZoomButton.css';

interface Props {
  zoomedIn?: boolean,
  resetZoom: () => void,
  isHidden?: boolean
}
export function ResetZoomButton(props: Props) {
  const { t } = useTranslation('performance');
  const { resetZoom, zoomedIn, isHidden } = props;
  return (
    <Button
      colour={ButtonColours.grey}
      className={`reset-zoom__button ${zoomedIn ? '' : isHidden ? 'reset-zoom__button--hidden' : 'reset-zoom__button--disabled'} panel-button`}
      text={t('RESET_ZOOM')}
      iconBeforeText={true}
      iconStyle="fas fa-undo-alt"
      disabled={!zoomedIn}
      onClick={resetZoom}
    />
  );
}
